(function () {
  var gate = document.querySelector("[data-weathercraft-age-gate]");
  if (!gate) return;

  var storageKey = gate.getAttribute("data-storage-key") || "wc_age_verified";
  var yesButton = gate.querySelector("[data-age-yes]");
  var noButton = gate.querySelector("[data-age-no]");

  function showGate() {
    gate.classList.add("is-visible");
    document.body.style.overflow = "hidden";
  }

  function hideGate() {
    gate.classList.remove("is-visible");
    document.body.style.overflow = "";
  }

  try {
    if (sessionStorage.getItem(storageKey)) {
      hideGate();
    } else {
      showGate();
    }
  } catch (error) {
    showGate();
  }

  if (yesButton) {
    yesButton.addEventListener("click", function () {
      try {
        sessionStorage.setItem(storageKey, "true");
      } catch (error) {
        // Continue without storage when the browser blocks sessionStorage.
      }
      hideGate();
    });
  }

  if (noButton) {
    noButton.addEventListener("click", function () {
      window.location.href = "about:blank";
    });
  }
})();

(function () {
  document.querySelectorAll("[data-wc-menu-toggle]").forEach(function (button) {
    var menuId = button.getAttribute("aria-controls");
    var menu = document.getElementById(menuId);

    if (!menu) return;

    function closeMenu() {
      button.setAttribute("aria-expanded", "false");
      button.setAttribute("aria-label", "Open menu");
      menu.hidden = true;
    }

    button.addEventListener("click", function () {
      var opening = button.getAttribute("aria-expanded") !== "true";

      button.setAttribute("aria-expanded", String(opening));
      button.setAttribute("aria-label", opening ? "Close menu" : "Open menu");
      menu.hidden = !opening;
    });

    menu.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", closeMenu);
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        closeMenu();
        button.focus();
      }
    });

    window.addEventListener("resize", function () {
      if (window.innerWidth > 900) closeMenu();
    });
  });
})();
